/*
  Use for verify user and get ssn only
*/

import { put, takeEvery, call } from 'redux-saga/effects';

import Actions from '../../../actions/3rd/signant.actions';
import * as actionTypes from '../../../actionTypes/ActionTypes';
import signantServices from '../../../../services/3rd/signant';
import rgbSsparebank1Service from '../../../../services/3rd/rgb/rgb.ssparebank1.service';
import companyUsersAssignPaymentServices from '../../../../services/companyUsersAssignPaymentServices';

export default function* handleAuthorizeCompanyBanksSaga() {
  yield takeEvery(actionTypes.SIGNANT.HANDLE_AUTHORIZE_COMANY_BANKS, handleAuthorizeCompanyBanks);
}

export function* handleAuthorizeCompanyBanks(action) {
  try {
    const { organisationNumber, accountNumbers, companyId, assignUser } = action.payload || {};

    if (!organisationNumber || !accountNumbers?.trim()) {
      yield put(Actions.handleAuthorizeCompanyBanksFail('Missing parameters'));
      return;
    }

    const arrAccountNumbers = accountNumbers
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);

    const authStatusResponse = yield call(signantServices.getAuthStatus, action.payload);

    if (!authStatusResponse?.success) {
      yield put(Actions.handleAuthorizeCompanyBanksFail(authStatusResponse?.data || 'Failed to get auth status'));
      return;
    }

    const ssn = authStatusResponse?.data?.UserSSN;

    if (!ssn) {
      yield put(Actions.handleAuthorizeCompanyBanksFail('SSN not found'));
      return;
    }

    const authResponse = yield call(rgbSsparebank1Service.crsAuthorize, {
      organisationNumber,
      ssn,
      accountNumbers: arrAccountNumbers,
    });

    if (!authResponse?.success) {
      yield put(Actions.handleAuthorizeCompanyBanksFail(authResponse?.message || authResponse));
      return;
    }

    const authorizeData = authResponse?.data;

    if (!Array.isArray(authorizeData)) {
      yield put(Actions.handleAuthorizeCompanyBanksFail('Invalid authorize data'));
      return;
    }

    // clear signant
    yield put(Actions.signantAuthSuccess({}));

    const isAllowPayments = authorizeData.map(({ statusCode, resData }) => {
      const approvalAccessIndicator = resData?.[0]?.approvalAccessIndicator;

      return statusCode === 200 && approvalAccessIndicator === 'OK' ? 1 : 0;
    });

    const updateResponse = yield call(companyUsersAssignPaymentServices.addUpdateBanksVerifiedPayment, {
      accountNumbers: arrAccountNumbers,
      companyId,
      isAllowPayments,
      assignUser,
    });

    if (!updateResponse?.success) {
      yield put(Actions.handleAuthorizeCompanyBanksFail(updateResponse?.message || 'Update failed'));
      return;
    }

    yield put(
      Actions.handleAuthorizeCompanyBanksSuccess({
        accountNumbers: arrAccountNumbers,
        authorizeData,
      }),
    );
  } catch (error) {
    yield put(Actions.handleAuthorizeCompanyBanksFail(error?.message || 'Unexpected error'));
  }
}
